define([], () => ({
  UPDATE_SEGMENTS_SETTING: 'UPDATE_SEGMENTS_SETTING',
  RECEIVE_SEGMENT: 'RECEIVE_SEGMENT',
  RECEIVE_SEGMENTS: 'RECEIVE_SEGMENTS',
  RECEIVE_SEGMENT_EMAILS: 'RECEIVE_SEGMENT_EMAILS',
  RECEIVE_SEGMENT_CONTACTS: 'RECEIVE_SEGMENT_CONTACTS',
  RECEIVE_SEGMENT_ESTIMATE: 'RECEIVE_SEGMENT_ESTIMATE',
  REMOVE_SEGMENT: 'REMOVE_SEGMENT',
}));
